import styled from 'styled-components';


export const Container = styled.div`
  > header {
    height: 144px;
    background: #28262e;
    display: flex;
    align-items: center;
     div {
      width:100%;
      max-width: 1200px;
      margin: 0 auto;
      svg{
        color: #999591;
        height: 24px;
        width: 24px;
      }
     }   
     
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: -170px auto ;
  /* width: 100%; */
  form {
    margin: 80px 0;
    width: 340px;
    text-align: center;
    display: flex;
    flex-direction: column;
    h1 {
      margin-bottom: 24px;
      font-size: 20px;
      text-align: left;
    }
    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.2s;
      &:hover {
     
      }
    }
  }
`;

export const AvatarInput = styled.div`
margin-bottom: 32px;
position: relative; 
align-self: center;
img{
  width: 186px;
  height: 186px;
  border-radius: 50%;
  }
label{
  position:absolute;
  width:48px;
  height:48px;
  background: #ff9000;
  border-radius: 50%;
  right: 0;
  bottom: 0;
  cursor: pointer;
  border: 0;
  display:flex;
  align-items:center;
  justify-content: center;
  input{
    display: none;  
  }
  svg{
    height: 20px;
    width: 20px;
    color: #312e38;
  }
}
`;
